// @flow
import { createSelector } from 'reselect';

// selectors
import { getAppName } from 'store/reducers/userInteractions/selectors';

// Utils
import { isMobile } from 'utils/DOM';

// Constants
import { APP_NAMES } from 'constants/appName';

export const getOptimizelyABTest = (state: any) => state.optimizelyABTest;

export const servicesFormOptimizely = createSelector(
  getOptimizelyABTest,
  optimizelyABTest =>
    optimizelyABTest &&
    optimizelyABTest.CP8 &&
    optimizelyABTest.CP8.servicesPage &&
    optimizelyABTest.CP8.servicesPage.amountServicesOptimizely
      ? optimizelyABTest.CP8.servicesPage.amountServicesOptimizely
      : false
);

export const getCTABanner = createSelector(
  getOptimizelyABTest,
  getAppName,
  (optimizelyABTest, appName) =>
    optimizelyABTest &&
    optimizelyABTest.CP8 &&
    optimizelyABTest.CP8.CTABanner &&
    !isMobile() &&
    appName === APP_NAMES.CONSUMER_8
      ? optimizelyABTest.CP8.CTABanner
      : null
);

export const getTopCTA = createSelector(
  getCTABanner,
  getCTABanner =>
    getCTABanner && getCTABanner.topCTA ? getCTABanner.topCTA : null
);

export const hideBottomCTA = createSelector(
  getCTABanner,
  getCTABanner =>
    getCTABanner && getCTABanner.hideBottomCTA
      ? getCTABanner.hideBottomCTA
      : false
);

export const showProgressBar = createSelector(
  getCTABanner,
  getCTABanner =>
    getCTABanner && getCTABanner.showProgressBar
      ? getCTABanner.showProgressBar
      : false
);

export const getBackButton = createSelector(
  getCTABanner,
  getCTABanner =>
    getCTABanner && getCTABanner.backButton ? getCTABanner.backButton : null
);

export const getBookItButton = createSelector(
  getOptimizelyABTest,
  getAppName,
  (optimizelyABTest, appName) =>
    optimizelyABTest &&
    optimizelyABTest.CP8 &&
    optimizelyABTest.CP8.bookItButton
      ? optimizelyABTest.CP8.bookItButton
      : null
);

export const getShowBookItButtonLabel = createSelector(
  getBookItButton,
  ({ showBookItButtonLabel }) => showBookItButtonLabel
);

export const showSCIProgressBar = createSelector(
  getOptimizelyABTest,
  getAppName,
  (optimizelyABTest, appName) =>
    optimizelyABTest &&
    optimizelyABTest.SCI &&
    optimizelyABTest.SCI.showProgressBar &&
    appName === APP_NAMES.SELF_CHECK_IN
      ? optimizelyABTest.SCI.showProgressBar
      : false
);



// WEBPACK FOOTER //
// ./src/store/reducers/optimizelyABTest/selectors.js